import React, { useEffect } from 'react'
import { Button, Input, Table } from 'reactstrap'
import { AiOutlineEdit, AiOutlineDelete } from "react-icons/ai"
import { Link } from 'react-router-dom'
import { Spinner } from "reactstrap"
import axios from 'axios'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import { toast } from 'react-toastify'
import { MdAdd } from 'react-icons/md'
import Pagination from '../../Components/Paginate'
import { getAdminUsers } from '../../redux/actions/indexActions'
const AdminUsers = () => {
    const [search, setSearch] = useState("");
    const [sort, setSort] = useState("desc");
    const [page, setPage] = useState(0);
    const [paginate, setPaginate] = useState(10);
    const { AuthReducer: { auth }, indexReducer: { adminUsers, adminUserCount }, PermissionReducer: { allowedPermissions }, } = useSelector(state => state)
    const dispatch = useDispatch();
    const indexOfLastItem = (page + 1) * paginate;
    const indexOfFirstItem = indexOfLastItem - paginate;
    useEffect(() => {
        dispatch(getAdminUsers(auth?.token, paginate, page, search, sort))
    }, [auth, paginate, page, search, sort]);

    const handleDel = (id) => {
        if (window.confirm("Are You Sure You Want To Delete This Admin User")) {
            axios
                .delete(`/api/admin/v1/admin-user/delete/${id}`, {
                    headers: {
                        Authorization: `Bearer ${auth?.token}`,
                    },
                })
                .then((res) => {
                    toast.success(res.data.message);
                    dispatch(getAdminUsers(auth?.token));
                })
                .catch((err) => toast.error("Somthing Went Wrong"));
        }
    };

    return (
        <div>
            <div className="row my-3">
                <div className="col-md-12">
                    <div className="d-flex align-items-center justify-content-between">
                        <h5 className='mb-0 text-white'>Admin Users</h5>
                        {allowedPermissions?.some?.((item) => item?.permission?.moduleType === "ADMINUSER" && item?.permission?.permission === "create") && (
                            <Link to="/add-admin-user" >
                                <Button className='bg-white text-black' style={{ color: "primary" }} size='sm' >
                                    <span className='me-2' >
                                        <MdAdd size={22} />
                                    </span>
                                    Add Admin User
                                </Button>
                            </Link>
                        )}
                    </div>
                </div>
            </div>
            <div className='bg-white px-3 py-3 rounded-2  my-4'>
                <div className="row">
                    <div className="col-md-3 mb-2 ">
                        <Input
                            size={"sm"}
                            value={search}
                            placeholder="Search By Name, Email Or Mobile"
                            onChange={({ target: { value } }) => setSearch(value)}
                        />
                    </div>
                    <div className="col-md-2 ">
                        <Input
                            type="select"
                            size={"sm"}
                            value={sort}
                            onChange={({ target }) => setSort(target.value)}
                        >
                            <option value="asc">Ascending</option>
                            <option value="desc">Descending</option>
                        </Input>
                    </div>
                    <div className="col-md-12">
                        <Table
                            hover
                            responsive
                        >
                            <thead>
                                <tr>
                                    <th>SL. No.</th>
                                    <th>Name</th>
                                    <th>Mobile</th>
                                    <th>Email</th>
                                    <th>Role</th>
                                    <th>Status</th>
                                    {allowedPermissions?.some?.(
                                        (item) =>
                                            item?.permission?.moduleType === "ADMINUSER" &&
                                            (item?.permission?.permission === "edit" ||
                                                item?.permission?.permission === "delete")
                                    ) && (
                                            <th>Action</th>
                                        )}
                                </tr>
                            </thead>
                            <tbody>
                                {adminUsers.length === 0 ? (
                                    <tr>
                                        <td colSpan="6">No data found</td>
                                    </tr>
                                ) : (<>
                                    {adminUsers.map((item, index) => {
                                        return <tr key={item.id}>
                                            <th scope="row">
                                                {index + 1 + page * paginate}
                                            </th>
                                            <td>
                                                {item.name}
                                            </td>
                                            <td>
                                                {item.mobile}
                                            </td>
                                            <td>
                                                {item.email}
                                            </td>
                                            <td>
                                                {item.role?.name}
                                            </td>
                                            <td>
                                                {item?.status ? "Active" : "Inactive"}
                                            </td>
                                            <td>
                                                <div className="d-flex align-items-center">
                                                    {allowedPermissions?.some?.(
                                                        (item) =>
                                                            item?.permission?.moduleType === "ADMINUSER" &&
                                                            item?.permission?.permission === "edit"
                                                    ) && (
                                                            <Link to={`/admin-users/edit/${item?.id}`}>
                                                                <AiOutlineEdit size={22} className='text-warning me-3' />
                                                            </Link>
                                                        )}
                                                    {allowedPermissions?.some?.(
                                                        (item) =>
                                                            item?.permission?.moduleType === "ADMINUSER" &&
                                                            item?.permission?.permission === "delete"
                                                    ) && (
                                                            <AiOutlineDelete size={22} className='text-danger' onClick={() => handleDel(item.id)} />
                                                        )}
                                                </div>
                                            </td>
                                        </tr>
                                    })}</>
                                )}
                            </tbody>
                        </Table>
                    </div>
                </div>
                <div className="row align-items-center">
                    <div className="col-md-6 d-flex">
                        <div className="col-md-2">
                            <Input
                                type="select"
                                id="paginate"
                                onChange={e =>
                                    setPaginate(
                                        e.target.value
                                    )
                                }
                                value={paginate}
                                className="paging custom-select custom-select-page m-0"
                            >
                                <option value="10">
                                    10
                                </option>
                                <option value="20">
                                    20
                                </option>
                                <option value="50">
                                    50
                                </option>
                                <option value="100">
                                    100
                                </option>
                                <option value="200">
                                    200
                                </option>
                                <option value="500">
                                    500
                                </option>
                            </Input>
                        </div>
                        <div className='col-md-10 text-black d-flex align-items-center ps-3'>
                            Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, adminUserCount)} of {adminUserCount} entries
                        </div>
                    </div>
                    <div className='col-md-6'>
                        <div className='d-flex justify-content-end'>
                            <Pagination
                                pageCount={(adminUserCount) / paginate}
                                onChange={(e) => setPage(e.selected)}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default AdminUsers